<template>
    <div class="main-page-units-and-shops">
      <v-card class="units">
        <v-toolbar
          color="#E72480"
          dark
        >

          <v-toolbar-title style="font-weight: bold;font-size: 2rem">واحد های فروشگاه</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn icon @click="addDialog" >
            <v-icon>mdi-plus-thick  </v-icon>
          </v-btn>
        </v-toolbar>
        <div class="empty-array" v-if="originalUnits.length===0">اطلاعاتی برای نشان دادن نداریم.</div>
        <div class="empty-array" v-if="originalUnits.length===0">لطفا اطلاعات جدید را وارد کنید.</div>
        <div  class="child-offer">
          <v-card
            v-for="item in originalUnits"
            max-width="344"
          >
            <div class="image">
              <v-img
                :src="item.file ? baseUrl+item.file+ '?'+ dates : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU' "
                height="250px"
                lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <div class="icons">
                <v-btn :loading="loadingDelete" style="background-color: white" @click="deleteData(item.id)" icon>
                  <v-icon color="red">mdi-delete  </v-icon>
                </v-btn>
                <v-btn @click="editData(item.image , item.text,item.title,item.category , item.id,baseUrl+item.file)" style="background-color: white" icon>
                  <v-icon color="blue" >mdi-pencil  </v-icon>
                </v-btn>
              </div>
            </div>
            <v-divider></v-divider>
            <v-card-title style="display: flex">
              <div class="ml-1"  style='font-weight: bold'>
                 عنوان:
              </div>
              <div>
                {{item.title}}
              </div>
            </v-card-title>
            <v-card-text style="display: flex">
              <div class="ml-1" style="font-weight: bold;font-size: 18px">
                متن:
              </div>
              <div>
                {{item.text}}
              </div>
            </v-card-text>
            <v-card-text style="display: flex">
              <div class="ml-1" style="font-weight: bold;font-size: 18px">
                موقعیت:
              </div>
              <div>
                {{item.category}}
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-card>
      <v-dialog
        v-model="dialog"
        max-width="800"
        v-on:click:outside="eybiyokh"

      >

             <v-card style="background-color: #d2d2d2;padding: 40px">
     <v-form
       ref="form"
       v-model="valid"
       validation>
          <v-container >
            <v-row>
              <v-file-input
                v-model="files"
                class="input"
                chips
                placeholder=""
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                v-on:change="showImage($event)"
                v-on:click:clear="deleteImage"
                required
              ></v-file-input>
              <p class="text">عکس مورد نظر خود را اپلود کنید</p>
            </v-row>
          </v-container>
       <div style="display: flex;justify-content: flex-start;align-items: flex-start">
         <div style="font-weight: bold;margin: 15px 0 15px 15px;">عنوان اسلاید:</div>
         <v-text-field
           class="title-input"
           style="max-width: 500px"
           label="عنوان"
           :rules="[titleRule]"
           v-model="title"
           placeholder="عنوان"
           solo
         ></v-text-field>
       </div>
          <v-textarea
            class="text-input"
            counter
            label="متن اسلایدر مورد نظر را وارد کنید"
            row-height="5"
            :rules="[textRule]"
            v-model="text"
            rows="2"
            required
          ></v-textarea>
       <div style="display: flex;justify-content: flex-start;align-items: flex-start">
         <div style="font-weight: bold;margin: 15px 0 15px 15px;">موقعیت اسلاید:</div>
         <v-select
           style="flex-direction: column-reverse;max-width: 300px;width: 300px !important;"
           :items="items"
           label="موقعیت"
           solo
           required
           v-model="categories"
           :rules="[categoriesRules]"
         ></v-select>
       </div>
       <v-img width="300" height="200" :src="image"></v-img>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="black darken-1"
              text
              @click="eybiyokh()"
            >
              بیخیال
            </v-btn>
            <v-btn
              color="black darken-1"
              text
              @click="sendData"
              v-show="!isEdit"
              :disabled="!valid"
              :loading="sendLoading"
            >
              انجام شد
            </v-btn>
            <v-btn
              color="black darken-1"
              text
              @click="recordData"
              :loading="editLoading"
              v-show="isEdit"
              :disabled="!valid"

            >
              ویرایش کنید.
            </v-btn>
          </v-card-actions>
     </v-form>

             </v-card>
      </v-dialog>
    </div>
</template>

<script>
    import {toBase64} from "../../../plugins/toBase64";
    import {deleteUnits, putUnits, setUnits} from "../../../api/mainpage/units";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "mainPageUnitsAndShops",
      data:()=>({
        dialog:false,
        isEdit:false,
        baseUrl:'',
        id:0,
        text:'',
        image:'',
        title:'',
        categories:'',
        files:[],
        fileCheck:true,
        textCheck:true,
        sendLoading:false,
        editLoading:false,
        deleteLoaiding:false,
        valid:true,
        location:0,
        isData:false,
        items:['چپ بالا','راست بالا','چپ پایین','راست پایین'],
        dates:'',

        textRule: v =>{
          if(v !== '' && v.length <=226)
          {
            return true
          }
          else
          {
            return 'متن وارد شده باید کمتر از ۲۲۶ کاراکتر باشد.'
          }
        },
        titleRule: v =>{
          if(v !== '' && v.length <=80)
          {
            return true
          }
          else
          {
            return 'تیتر وارد شده باید کمتر از ۸۰ کاراکتر باشد.'
          }
        },
        categoriesRules : v =>{
          if(v!=='' && v!==undefined)
          {
            return true
          }
          else
          {
            return 'جای اسلایدر را مشخص کنید'
          }
        }
      }),
      methods:{
        showImage(e){
          if(e) {
            this.image = URL.createObjectURL(e)
          }
        },
        deleteImage()
        {
          this.image = ''
        },
        addDialog () {
          this.isEdit = false
          this.dialog = true
        },
        async sendData(){
          this.sendLoading = true
          switch (this.categories) {
            case "چب بالا":
              this.location = 0
              break;
            case "راست بالا":
              this.location = 1
              break;
            case "چپ پایین":
              this.location = 2
              break;
            case "راست پایین":
              this.location = 3
              break;
            default:
              this.location = 0
          }
          let img = this.files ? await toBase64(this.files) : null
            await setUnits({
              imgPath:img,
              text:this.text,
              title:this.title,
              location:this.location
            }).then(()=>{
              this.dates = new Date()
              this.getUnitsReq().then(()=>{
                this.originalUnits =this.originalUnits.map((item)=>{
                  switch (item.location) {
                    case 0:
                      item.category = 'چب بالا'
                      break
                    case 1:
                      item.category = 'راست بالا'
                      break
                    case 2:
                      item.category = 'چپ پایین'
                      break
                    case 3:
                      item.category = 'راست پایین'
                      break
                  }
                })

              })
              this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
            }).catch(()=>{
              this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
            })
          this.sendLoading=false
          this.dialog = false
          this.files=[]
          this.text=''
          this.title = ''
          this.categories = ''
          this.image = ''
        },
        async recordData(){
          this.editLoading = true
          switch (this.categories) {
            case "چب بالا":
              this.location = 0
              break;
            case "راست بالا":
              this.location = 1
              break;
            case "چپ پایین":
              this.location = 2
              break;
            case "راست پایین":
              this.location = 3
              break;
            default:
              this.location = 0
          }
          let img = this.files ? await toBase64(this.files) : null
          await putUnits({
              imgPath:img,
              text:this.text,
              title:this.title,
              location:this.location
            },this.id).then(()=>{
              this.dates  = new Date()
            this.getUnitsReq().then(()=>{
                this.originalUnits =this.originalUnits.map((item)=>{
                  switch (item.location) {
                    case 0:
                      item.category = 'چب بالا'
                      break
                    case 1:
                      item.category = 'راست بالا'
                      break
                    case 2:
                      item.category = 'چپ پایین'
                      break
                    case 3:
                      item.category = 'راست پایین'
                      break
                  }
                })

              })
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
            // window.location.reload()
            }).catch(()=>{
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          })

          this.dialog = false
          this.files=[]
          this.text=''
          this.title = ''
          this.categories = ''
          this.image= ''
          this.editLoading = false
        },
        eybiyokh(){
          this.dialog = false
          this.files=[]
          this.text=''
          this.title = ''
          this.categories = ''
          this.image= ''
        },
        deleteData(id){
          let yes = confirm("مطمئنی میخوای پاک کنی!");
          this.loadingDelete = true
          if (yes) {
            this.files=[]
            deleteUnits(id).then(() => {
              this.getUnitsReq()
            }).then(()=>{
              this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
            }).catch(()=>{
              this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
            })
            this.loadingDelete = false
          }

        },
        editData(image, text ,title,category, id,path){
          this.files = image
          this.text = text
          this.id=id
          this.title = title
          this.categories= category
          this.image = path +'?'+this.dates
          this.dialog = true
          this.isEdit = true
        },
        ...mapActions({
          getUnitsReq:'MainPageUnitsStore/fetchUnits',
          snackBarAction:'snackBar/snackBarAction'
        }),
      },
      computed: {
        ...mapGetters({
          originalUnits: 'MainPageUnitsStore/get_units',
        })

      },
      mounted() {
          this.dates = new Date()
          this.baseUrl = process.env.VUE_APP_BASE_URL
          this.getUnitsReq().then(()=>{
            this.originalUnits =this.originalUnits.map((item)=>{
               switch (item.location) {
                 case 0:
                     item.category = 'چب بالا'
                     break
                 case 1:
                   item.category = 'راست بالا'
                   break
                 case 2:
                   item.category = 'چپ پایین'
                   break
                 case 3:
                   item.category = 'راست پایین'
                   break
               }
            })
          })
      }
    }
</script>

<style>
  .units .v-icon.v-icon::after{
    background-color: unset;
  }
  .text-input .v-label.v-label  {
    font-size: 1.1rem !important;
    top: 0;
  }
  .text-input .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot{
    height: 2rem !important;
  }
  .text-input .v-textarea textarea{
    font-size: 1.25rem;
  }
  .date-input{
    margin-bottom: 2rem;
  }
 .main-page-units-and-shops .v-responsive__content{
    width: 344px !important;
  }
</style>

<style scoped>
  .units{
    width: 85%;
    margin: 0 auto;
  }
  .child-offer{
    padding: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .card-offer{
    margin: 0;
  }
  .form-slider{
    display: flex;
    flex-direction: column;
    max-width: 1185px;
    margin: 0 auto;
  }
  .title-input
  {
    min-height: unset;
  }
  .input{
    direction: ltr;
  }
  .row{
    justify-content: center;
    align-items: flex-end;
    flex-direction: row-reverse;
  }
  .text{
    font-family: anjoman;
    font-size: 1.25rem;
  }

  .link-input{
    width: 40%;
  }
  .image{
    position:  relative;
  }
  .icons{
    position: absolute;
    top: 0;
    left: 0;
  }
  .empty-array{
    font-size: 2rem;
    margin-right: 3rem;
    font-weight: bold;
  }
</style>
